import { useAuthStore } from './authStore';

export function useAuth() {
  const token = useAuthStore((s) => s.token);
  const expiresAt = useAuthStore((s) => s.expiresAt);
  const user = useAuthStore((s) => s.user);
  const role = useAuthStore((s) => s.role);
  const permissions = useAuthStore((s) => s.permissions);
  const app = useAuthStore((s) => s.app);
  const logout = useAuthStore((s) => s.logout);

  return {
    isAuthenticated: !!token,
    token,
    expiresAt,
    user,
    role,
    permissions,
    app,
    companyId: user?.companyId ?? null,
    hasBrandKit: !!user?.hasBrandKit,
    isPending: role === 'staff' || role === 'viewer',
    logout,
  };
}
